import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { IconComponent } from '@components/icon/icon.component';

import { SortableProp } from './sort-nav.directive';

@Directive({
  selector: '[sortKey]',
})
export class SortKeyDirective implements AfterViewInit {
  @Input()
  sortKey: string | null = null;

  @Input()
  sortOrder: number;

  @Input()
  sortDirection: 'asc' | 'desc' | null = null;

  @Output()
  keyClicked: EventEmitter<SortableProp> = new EventEmitter();

  constructor(
    private readonly element: ElementRef<HTMLTableCellElement>,
    private readonly viewContainerRef: ViewContainerRef,
  ) {}

  @HostListener('click')
  onClick(): void {
    if (this.sortKey) {
      this.toggleSort();
      this.keyClicked.emit({ key: this.sortKey, direction: this.sortDirection });
    }
  }

  ngAfterViewInit(): void {
    if (this.sortKey) {
      this.buildSortNav();
      this.element.nativeElement.classList.add('cursor-pointer', 'hover:opacity-75');
    }
  }

  buildSortNav(): void {
    this.clearSortNavElement();
    this.element.nativeElement.appendChild(this.getSortNavElement());
  }

  private toggleSort(): void {
    switch (this.sortDirection) {
      case null:
        this.sortDirection = 'asc';
        break;
      case 'asc':
        this.sortDirection = 'desc';
        break;
      case 'desc':
        this.sortDirection = null;
        break;
    }
    this.buildSortNav();
  }

  private getSortNavElement(): HTMLElement {
    const spanNav = document.createElement('span');
    spanNav.className = 'sort-nav ml-4 inline-flex items-center gap-1';
    if (this.sortDirection) {
      const sortLabel = document.createElement('span');
      spanNav.appendChild(sortLabel);
      sortLabel.className = 'sort-nav__label';
      sortLabel.textContent = this.sortOrder ? `(${this.sortOrder})` : '';

      const appIconRef = this.viewContainerRef.createComponent(IconComponent);
      spanNav.appendChild(appIconRef.location.nativeElement);
      appIconRef.location.nativeElement.className = 'inline-block';

      if (this.sortDirection === 'asc') {
        appIconRef.instance.name = 'arrow-up';
      } else if (this.sortDirection === 'desc') {
        appIconRef.instance.name = 'arrow-down';
      }
    }
    return spanNav;
  }

  private clearSortNavElement(): void {
    const prevSortNav = this.element.nativeElement.querySelector('.sort-nav');
    if (prevSortNav) {
      prevSortNav.parentNode.removeChild(prevSortNav);
    }
  }
}
